module.exports = __webpack_public_path__ + "static/media/leaves1.3c8e58a3.png";